"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CookieSameSite;
(function (CookieSameSite) {
    CookieSameSite["strict"] = "strict";
    CookieSameSite["lax"] = "lax";
    CookieSameSite["none"] = "none";
})(CookieSameSite || (CookieSameSite = {}));
exports.default = CookieSameSite;
//# sourceMappingURL=CookieSameSite.js.map